/**
 * Quick Links Component
 * @module patterns/components/quick-links
 */

import { scrollIntoView } from '@root/src/framework/scripts/utils/scroll';
import { App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Quick Links Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountFreeTextQuickLinks(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Quick Links component', error);
        });

    return function destroyFreeTextQuickLinks() {
        unMountFreeTextQuickLinks(listeners);

        app.logger.debug('[DXA] Quick Links component destroyed');
    };
}

// Extracted method for logic reuse within other component
export function mountFreeTextQuickLinks(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null) {
    let rootNode: Document | HTMLElement = document;
    if (root)
        rootNode = root;

    const freeText = [...rootNode.querySelectorAll<HTMLElement>('.free-text')];
    const allQuickLinks = rootNode.querySelectorAll<HTMLElement>('.quick-links');
    const headings = freeText.flatMap(x => [...x.querySelectorAll<HTMLElement>('h2')]);

    for (const quickLinks of allQuickLinks) {
        const defaultLink = quickLinks.querySelector<HTMLElement>('.quick-link.default');
			 const header = document.querySelector('.quick-links')

        const quickLinksDiv = defaultLink?.nextElementSibling;
        if (headings && defaultLink && quickLinksDiv){

            for (const h2 of headings)
            {
                const idValue = h2.textContent?.replaceAll(" ", "-").toLowerCase() ?? '';
                const headingText = h2.textContent ?? ''
                const a = defaultLink.cloneNode(true) as HTMLElement;
					 a.classList.remove('default');

                h2.id = idValue;
                a.setAttribute("href", `#${idValue}`);
                const linkText = document.createTextNode(headingText);
                a.prepend(linkText);
                a.classList.toggle('hidden');

                quickLinksDiv.append(a);


                // eslint-disable-next-line @typescript-eslint/no-loop-func
                const scrollToHeading = (event: Event) => {
                    event.preventDefault();
                    if (event.target instanceof Element) {
                        scrollIntoView(h2)
                    }
                }

                a.addEventListener("click", scrollToHeading);
                listeners.push([a, "click", scrollToHeading]);
            }

            if (header != null){
                const stickyHeading = header.querySelector('.quick-links-header')
                if (stickyHeading != null){
                     	quickLinksDiv.prepend(stickyHeading)
                }
            }

            quickLinks.append(quickLinksDiv)
				 defaultLink?.remove();
        }
    }
}

export function unMountFreeTextQuickLinks(listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
